<template>
	<page>
		<module title="商品统计" enable-flex>
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="商品ID">
					<c-input name="product_id" type="number" decimal="0" :limit="[1,999999999]"></c-input>
				</m-search-item>
				<m-search-item label="货号">
				  <c-input name="product_itemnumber"></c-input>
				</m-search-item>
				<m-search-item label="规格">
				  <c-input name="product_sku_spec"></c-input>
				</m-search-item>
				<m-search-item label="商品类目">
				  <c-select name="product_type_id" options="PRODUCT_CLASSIFY"></c-select>
				</m-search-item>
				<m-search-item label="统计时间" colspan="2">
					<c-datetime start-name="start_date" end-name="end_date" type="date" range></c-datetime>
				</m-search-item>
			</m-search>
			
			<c-table ref="table" height="grow">
				<c-table-column
					label="商品ID"
					width="80"
					name="product_id"
				></c-table-column>
				
				<c-table-column
					label="商品"
					name="product_name"
					width="350"
				>
					<template #default="{data}">
						<div class="flex-center-cross">
							<c-file media :src="data.product_img_url" style="margin-right: 18px;"></c-file>
							<p v-if="data.product_itemnumber">{{data.product_itemnumber}} - </p>
							<p>{{data.product_name}}</p>
						</div>
					</template>
				</c-table-column>
				
				<c-table-column
					label="规格"
					name="product_sku_spec"
					width="120"
				>
				</c-table-column>
				
				<c-table-column
					label="所属类目"
					name="product_type_full_name"
					width="220"
				>
				</c-table-column>
				
				<c-table-column
					label="销量"
					name="sales_quantity"
					width="70"
				>
				</c-table-column>
				
				<c-table-column
					label="销售额"
					name="sales_amount"
					width="110"
				>
					<template v-slot="{data}">
						￥{{data.sales_amount}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="支付人数"
					name="pay_user_quantity"
					width="70"
				>
				</c-table-column>
				
				<c-table-column
					label="退款数量"
					name="cancel_quantity"
					width="70"
				>
				</c-table-column>
				
				<c-table-column
					label="退款总额"
					name="cancel_amount"
					width="110"
				>
					<template v-slot="{data}">
						￥{{data.cancel_amount}}
					</template>
				</c-table-column>
				
				<!-- <c-table-column
					label="退货数量"
					name="return_quantity"
					width="70"
				>
				</c-table-column>
				
				<c-table-column
					label="退货总额"
					name="return_amount"
					width="110"
				>
					<template v-slot="{data}">
						￥{{data.return_amount}}
					</template>
				</c-table-column> -->
			</c-table>
		</module>
		
	</page>
</template>

<script>
	export default {
		name: 'm_product_analysis',
		
		data() {
			return {
				
			}
		},
		
		computed: {
			powerAllCheck() {
				
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/statistic/product/list',
					data
				});
			}
		}
	}
</script>